/*
### License

**Proprietary Software – All Rights Reserved**

© 2024 Vanyadoing. All rights reserved.

Unauthorized copying, distribution, modification, or any other use of the software in whole or in part is strictly prohibited and may result in civil and criminal penalties. This software is protected under the **Digital Millennium Copyright Act (DMCA)** and other applicable international and domestic laws.

By using this software, you agree to comply with all applicable copyright laws and regulations. Any infringement will be pursued to the fullest extent permitted by law.
*/

//hoverEffect,displayNav,pagination,preset
let objKeys = {
    arrow: ["opacity", "activeBackgroundColor", "width", "height", "backgroundColor", "borderRadius", "hoverOpacity", "iconColor", "iconWidth", "hoverBackgroundColor", "display"],
    paging: ["opacity", "width", "height", "borderRadius", "activeOpacity", "hoverBackgroundColor", "activeScale", "hoverOpacity", "backgroundColor", "activeBackgroundColor", "display"],
    sliderProps: ["responsiveBehavior", "itemWidth", "numberOfColumns", "numberOfRows", "gap", "padding", "perMove", "drag", "loop", "keyboard", "moveMode", "pause", "scrollSpeed", "interval", "hoverEffect", "displayNav", "pagination", "preset", "borderRadius", "buttonsBorder", "actionColor", "bgColor"],
    m_sliderProps: ["responsiveBehavior", "itemWidth", "numberOfColumns", "numberOfRows", "gap", "padding", "perMove", "drag", "loop", "keyboard", "moveMode", "pause", "scrollSpeed", "interval", "hoverEffect", "displayNav", "pagination", "preset", "borderRadius", "buttonsBorder", "actionColor", "bgColor"]
}

export function splitObjectToArrays(obj) {
    //const keys = Object.keys(obj);
    const values = Object.values(obj);
    // return { keys, values };
    return JSON.stringify(values)
}

export function combineArraysToObject(key, param) {
    const obj = {};
    const values = typeof param === "string" ? JSON.parse(param) : param;
    let keys = objKeys[key];
    keys.forEach((key, index) => {
        obj[key] = values[index];
    });
    return obj;
}
let objKeysGrid = {
    gridProps: [ "columns","rows","gapHorizontal","gapVertical","aspectRatio","loadMoreMode","loadMoreInitialCount","loadMoreIncrement","itemRoundedCorners","itemBorderWidth","itemBorderColor","itemAnimationType","itemAnimationDuration","loadMoreButtonColor","loadMoreButtonFont","loadMoreButtonBackground","loadMoreButtonBorderRadius","loadMoreButtonBorderWidth","loadMoreButtonBorderColor","loadMoreButtonHoverColor","loadMoreButtonHoverBackground","loadMoreButtonHoverBorder","playButtonWidth","playButtonInnerColor","playButtonOuterColor","title","videoTitleAlign","videoTitleFontFamily","videoTitleFontSize","videoTitleColor","videoTitlePaddingTop","videoTitleMaxLines","overlay","overlayFilter","buttonFontSize","buttonPaddingVertical","buttonPaddingHorizontal","gridMode","buttonText"],
    m_gridProps: [ "columns","rows","gapHorizontal","gapVertical","aspectRatio","loadMoreMode","loadMoreInitialCount","loadMoreIncrement","itemRoundedCorners","itemBorderWidth","itemBorderColor","itemAnimationType","itemAnimationDuration","loadMoreButtonColor","loadMoreButtonFont","loadMoreButtonBackground","loadMoreButtonBorderRadius","loadMoreButtonBorderWidth","loadMoreButtonBorderColor","loadMoreButtonHoverColor","loadMoreButtonHoverBackground","loadMoreButtonHoverBorder","playButtonWidth","playButtonInnerColor","playButtonOuterColor","title","videoTitleAlign","videoTitleFontFamily","videoTitleFontSize","videoTitleColor","videoTitlePaddingTop","videoTitleMaxLines","overlay","overlayFilter","buttonFontSize","buttonPaddingVertical","buttonPaddingHorizontal","gridMode","buttonText"]
}
  


export function combineGridArraysToObject(key, param) {
    const obj = {};
    const values = typeof param === "string" ? JSON.parse(param) : param;
    let keys = objKeysGrid[key];
    keys.forEach((key, index) => {
        obj[key] = values[index];
    });
    return obj;
}
     
     